import { render, staticRenderFns } from "./FantasyCardPlayer.vue?vue&type=template&id=8e767f2a&"
import script from "./FantasyCardPlayer.vue?vue&type=script&lang=js&"
export * from "./FantasyCardPlayer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports